// US companies must use a 9-digit EIN (XX-XXXXXXX). Mirrors backend app/schemas/company.py.
export const EIN_ERROR = 'EIN must be 9 digits, formatted XX-XXXXXXX';

export const isUSCountry = (country?: string | null): boolean => {
    const c = (country || 'US').trim().toUpperCase();
    return c === 'US' || c === 'USA' || c === 'UNITED STATES';
};

const isUS = isUSCountry;

export const isValidEin = (value?: string | null, country?: string | null): boolean => {
    if (!value) return false;
    const compact = String(value).replace(/\s/g, '');
    if (!isUS(country)) return compact.length > 0;
    if (!/^\d{2}-?\d{7}$/.test(compact)) return false;
    const digits = compact.replace(/\D/g, '');
    return digits !== '000000000' && !digits.startsWith('00');
};

/**
 * Generate a syntactically valid US EIN (XX-XXXXXXX) for the "Generate Unique" button.
 * The value must pass isValidEin: nine digits, not starting with 00.
 */
export const generateEin = (random: () => number = Math.random): string => {
    const digits = Array.from({ length: 9 }, () => Math.floor(random() * 10)).join('');
    const nine = digits.startsWith('00') ? `1${digits.slice(1)}` : digits;
    return `${nine.slice(0, 2)}-${nine.slice(2)}`;
};
